import styled from 'styled-components';

const StyledEmailTd = styled.div`
  line-height: 16px;

  .domain {
    color: rgba(0,0,0,40%);
    overflow-wrap: normal;
    
    &.black {
      color: rgba(0,0,0,85%);
    }
  }
  
`;

export { StyledEmailTd };
